// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-code.js';

import { paths } from '../generated/square-code';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-code', Original, paths);
